<template>
  <div ref="dialogContent">
    <ValidationObserver ref="obs">
      <div class="header-tab gap-1">
        <span class="" v-for="(item, index) in workflowList" :key="item.name" :style="getMenuStyle(item)">
          #{{ index + 1 }}. {{ item.title }}
        </span>
      </div>
      <div class="py-2 px-3 container" style="min-height: 100%;">
        <div class="row">
          <div :class="columns.length <= 6 ? 'col-12' : 'col-6'">
            <div class="pe-2" v-for="item in columnFirst" :key="item.name">
              <ValidateForm :disable="!checkPermissionFieldEdit(item.name)" :disableStorage="true"
                :storageList="app.storageAll" :item="item" :value="formData[item.name]"
                @input="onFieldInput(item.name, $event)" :selectOptions="defaultValue[item.name]"
                :contactEmployees="contactSwEmployees" :lockUnmanagedEmployees="true" />
            </div>
          </div>
          <div class="col-6" style="max-height: 390px;overflow-y: scroll;">
            <div class="pe-2" v-for="item in columnSecond" :key="item.name">
              <ValidateForm :disable="!checkPermissionFieldEdit(item.name)" :disableStorage="true"
                :storageList="app.storageAll" :item="item" :value="formData[item.name]"
                @input="onFieldInput(item.name, $event)" :selectOptions="defaultValue[item.name]"
                :contactEmployees="contactSwEmployees" :lockUnmanagedEmployees="true" />
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer py-2 d-flex justify-content-end">
          <el-button class="" size="medium" @click="closeDialog">Huỷ</el-button>
          <el-button class="" size="medium" type="primary" :disabled="!isDisable" @click="onSubmit">Hoàn
            thành</el-button>
        </span>
      </div>
    </ValidationObserver>
    <el-dialog title="Thêm mới kho dữ liệu" :visible.sync="showAddStorageDialog" @close="showAddStorageDialog = false"
      :close-on-click-modal="false" append-to-body width="500px">
      <ValidationProvider name="Tên kho" rules="required-input:tên kho" v-slot="{ errors }">
        <el-input v-model="newStorageName" placeholder="Nhập tên kho dữ liệu"></el-input>
        <InputError :message="errors[0]" />
      </ValidationProvider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddStorageDialog = false">Hủy</el-button>
        <el-button type="primary" @click="saveNewStorage">Lưu</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ValidateForm from '../common/ValidateForm.vue';
import workflow from "@/lib/apis/workflow";
import field from '@/lib/apis/field';
import { Message } from "element-ui";
import { HTTP } from '@/lib/http-common';

export default {
  components: { ValidateForm },
  data() {
    return {
      columns: [],
      columnFirst: [],
      columnSecond: [],
      formData: {},
      steps: [],
      selectedWorkflow: {},
      isDisable: true,
      selectOptions: [],
      selectionValue: '',
      showAddStorageDialog: false,
      defaultValue: {},
    };
  },
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  computed: {
    // `item` trong v-for của template là column, che mất prop `item` (contact),
    // nên phải lấy nhân viên của contact qua computed.
    contactSwEmployees() {
      return this.item.swEmployees || [];
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        this.validateFormData();

        if (newVal) {
          const provinceColumn = this.columns.find(
            (c) => c.type === "PROVINCE"
          );
          if (!provinceColumn) return;

          const selectedProvince = newVal[provinceColumn.name];

          const wardColumn = this.columns.find(
            (c) =>
              c.type === "WARD" &&
              Number(c.parentColumnId) === Number(provinceColumn.id)
          );
          
          if (!wardColumn) return;

          if (!Array.isArray(wardColumn._allOptions)) {
            wardColumn._allOptions = Array.isArray(wardColumn.selectOptions)
              ? wardColumn.selectOptions.slice()
              : [];
          }

          const selectedWard = newVal[wardColumn.name];

          if (selectedWard) {
            const wardOption = wardColumn._allOptions.find(
              (opt) => opt.value === selectedWard
            );

            this.$set(
              this.formData,
              provinceColumn.name,
              wardOption.parentValue
            );
          }

          if (!selectedProvince) {
            wardColumn.selectOptions = wardColumn._allOptions.slice();
            this.$set(this.formData, wardColumn.name, null);
            return;
          }

          let filtered = wardColumn._allOptions.filter(
            (opt) => opt.parentValue === selectedProvince
          );
          
          wardColumn.selectOptions = filtered;

          const currentWard = this.formData[wardColumn.name];
          if (!filtered.some((o) => o.value === currentWard)) {
            this.$set(this.formData, wardColumn.name, null);
          }
        }
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    errorSelectOption() {
      this.isDisable = false;
    },
    successSelectOption() {
      this.isDisable = true;
    },
    validateFormData() {
      const isValid = this.columns.every(col => {
        if (col.require) {
          const value = this.formData[col.name];
          return value !== null && value !== undefined && value !== "";
        }
        return true;
      });
      this.isDisable = isValid;
    },
    checkContentHeight() {
      if (this.columns.length > 6) {
        this.$emit('expand-dialog', true);
      }
      else {
        this.$emit('expand-dialog', false);
      }
    },
    // convertColumns() {
    //   this.columns.forEach((col) => {
    //     if(this.selectedWorkflow?.informationField){
    //       const matchedField = this.selectedWorkflow.informationField.find(field => field.name === col.name);
    //       col.isRequire = matchedField ? matchedField.require : false;
    //     }
    //   });   
    // },
    getDataColumn() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columnFirst.length < 6) {
          this.columnFirst.push(this.columns[i]);
        }
        else {
          this.columnSecond.push(this.columns[i]);
        }
      }
    },
    onFieldInput(name, val) {
      // luôn thay object để watcher bắt được
      this.formData = { ...this.formData, [name]: val };
    },
    convertData() {
      // build object mới 1 lần
      const fd = {};
      fd.displayName = this.item.displayName || null;
      fd.phone = this.item.phone || null;
      fd.email = this.item.email || null;

      this.selectedWorkflow = this.workflowList.find(workflow =>
        this.item.processAndWorkflow.some(
          item => item.workflowId === workflow.id && item.processId === this.app.globalProcessId
        )
      );

      fd.employees = this.item.swEmployees?.map(e => e.id) || [];
      fd.storage = this.item.storageId || null;

      this.columns.forEach(col => {
        if (['displayName', 'phone', 'email', 'employees', 'storage'].includes(col.name)) return;

        const lceItem = this.item.LCE?.find(i => i.name === col.name);
        const rawValue = lceItem ? lceItem.value : "";
        let value = null;

        if (col.columnType === "MultiSelect") {
          value = rawValue ? JSON.parse(rawValue) : [];
        } else if (col.columnType === "Array" || col.columnType === 'ArrayNumber') {
          const arr = rawValue ? JSON.parse(rawValue) : [];
          value = arr;
          const arrDefault = col.defaultValue ? JSON.parse(col.defaultValue) : [];
          this.$set(this.defaultValue, col.name, arrDefault.map((item, index) => ({ id: index + 1, value: item })));
        } else if (col.columnType === "Number") {
          value = rawValue !== "" && rawValue !== null ? new Intl.NumberFormat('en-US').format(rawValue) : null;
        } else if (col.columnType === "Date") {
          value = rawValue !== "" ? Number(rawValue) : "";
        } else {
          value = rawValue;
        }

        fd[col.name] = value;
      });

      this.formData = fd; // thay cả object
    },
    formatDateTimeShort(time) {
      var date = new Date(time);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var seconds = ("0" + date.getSeconds()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);

      return hours + ":" + minutes + ":" + seconds + " " + + day + "/" + month + "/" + date.getFullYear();
    },
    async fetchSteps() {
      try {
        const response = await workflow.getWorkflow();
        if (response) {
          this.steps = response.data.sort((a, b) => a.index - b.index);
        }
      } catch (error) {
        console.error("Error fetching steps:", error);
        Message.error("Đã xảy ra lỗi khi tải dữ liệu.");
      }
    },
    async fetchColumnsByDisplayColumn() {
      let columnData = [];
      const processId = this.app.globalProcessId;
      const currentProcessId = processId === 'all' ? 0 : processId;
      const res = await field.fetchAllColumns(currentProcessId);
      columnData = res.data || [];

      this.columns = columnData
        .filter((column) => {
          const hasPermission = this.checkPermissionFieldRead(column.name);
          return hasPermission;
        })
        .map((column) => {
          const matchedColumn = this.columnListByProcess.find(
            (c) => c.name === column.name
          );
          if (!matchedColumn) return null;

          return {
            ...matchedColumn,
            parentColumnId:
              column.parentColumnId ?? matchedColumn.parentColumnId ?? null,
            selectOptions: column.selectOptions ?? matchedColumn.selectOptions,
            type:
              matchedColumn.type ??
              matchedColumn.columnType ??
              column.type ??
              column.columnType,
            columnType:
              matchedColumn.columnType ??
              column.columnType ??
              matchedColumn.type ??
              column.type,
          };
        })
        .filter((column) => column !== null);

      this.getDataColumn();
      this.checkContentHeight();
      this.convertData();
      // this.convertColumns();
    },
    async saveContact() {
      const columnRequests = [];
      this.columns.forEach((col)=>{
        if(!['displayName','phone','email','employees','storage'].includes(col.name)){

          let value = this.formData[col.name];

          if (col.columnType === "Number") {
            if (value !== null && value !== undefined && value !== '') {
              value = parseFloat(String(value).replace(/,/g, ''));
            } else {
              value = null;
            }
          }
          else if (col.columnType === "Date") {
            value = value
              ? new Date(value).getTime()
              : null;
          }
          else if (col.columnType === "Text") {
            value = value ? String(value).trim() : null;
          }
          else if (["MultiSelect", "Array", "ArrayNumber"].includes(col.columnType)) {
            let arr = [];

            if (Array.isArray(value)) {
              arr = value;
            } else if (typeof value === "string") {
              arr = value
                .split(";;")
                .map(v => v.trim())
                .filter(v => v !== "");
            }

            if (col.columnType === "ArrayNumber") {
              arr = arr
                .map(v => Number(v))
                .filter(v => !isNaN(v));
            }

            value = arr.length ? JSON.stringify(arr) : null;
          }
          else if (col.columnType === "SingleSelect") {
            value = value || null;
          }

          columnRequests.push({
            id: col.id,
            name: col.name,
            value: value
          });
        }
      });

      const request = {
        id: this.item.id,
        processId: this.app.globalProcessId,
        // workflowId của contact tại process đang thao tác (contact có thể ở nhiều quy trình).
        workflowId: (this.item.processAndWorkflow || []).find(
          pw => pw.processId === this.app.globalProcessId
        )?.workflowId ?? this.item.workflowId,
        displayName: this.formData['displayName']
          ? this.formData['displayName'].trim()
          : '',
        phone: this.formData['phone'],
        email: this.formData["email"]
          ? this.formData["email"].trim()
          : null,
        employeeIds: this.formData['employees']
          ? this.formData['employees']
          : [],
        storageId: this.formData['storage'] || null,
        columns: columnRequests
      };

      const res = await HTTP.put('/api/contact/update', request);

      if(res.error) {
        this.alert('error', res.error.message);
        return;
      }
      if (res.status === 'success') {
        this.$emit('success', [this.item.id]);
        this.alert('success','Thành công');
      }
    },
    handleAddNewStorage() {
      this.showAddStorageDialog = true;
    },
    async saveNewStorage() {
      let body = {
        name: this.newStorageName.trim()
      }
      const res = await HTTP.post("/api/storage/create", body);
      if (res.error?.message) {
        this.$message.error(res.error.message);
        return;
      }
      const res1 = await HTTP.get("/api/storage/get-all");
      this.$set(this.app, "storageAll", res1.data.storageList);
      this.$set(this.app, "storageList", res1.data.storageOptions);
      this.showAddStorageDialog = false;
    },
    closeDialog() {
      this.$emit('close');
      this.formData = {};
    },
    onSubmit() {
      this.$refs.obs.handleSubmit(async () => {
        await this.saveContact();
      });
    },
    getMenuStyle(type) {
      return type?.id == this.selectedWorkflow?.id ? this.activeMenuStyle(type?.color) : this.normalMenuStyle(type?.color);
    },
    activeMenuStyle(color) {
      //#0A58C0
      return {
        "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        "font-weight": "bold",
        color: color,
        "background-color": this.setTransparencyHex(color, 0.1)
      };
    },
    normalMenuStyle(color) {
      //#696B72
      return {
        //   "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        color: color,
        "font-weight": "500",
        "background-color": "transparent"
      };
    },
    setTransparencyHex(hex, opacity) {
      let color = hex.substring(1, hex.length);
      var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return "#" + color + _opacity.toString(16).toUpperCase();
    },
  },
  created() {
    // this.fetchSteps();
    this.fetchColumnsByDisplayColumn();
  },
  mounted() {
    window.addEventListener('resize', this.checkContentHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkContentHeight);
  },
};
</script>

<style scoped lang="scss">
.header-tab {
  background: #f6f6f6;
  padding: 6px 16px;
  border-bottom: 1px #ECECEC solid;
  cursor: pointer;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
}

.header-tab::-webkit-scrollbar {
  height: 6px !important;
}

.header-tab span {
  padding: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1%;
  color: #696B72;
  border-radius: 4px;
}

.header-tab span.active {
  color: #1769D7;
  background: #E1EDFD;
  font-weight: 700;
}
</style>
